import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnixFileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 36,
	viewBox: "0 0 32 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1_38815)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 5.40039,
				y: 3.82495,
				width: 24.3,
				height: 28.35,
				rx: 5,
				fill: "#528BFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.40039 25.0874H29.7004V27.1749C29.7004 29.9363 27.4618 32.1749 24.7004 32.1749H10.4004C7.63897 32.1749 5.40039 29.9363 5.40039 27.1749V25.0874Z",
				fill: "#0040C1"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 17.5508,
				y: 18,
				width: 12.15,
				height: 7.0875,
				fill: "#155EEF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 5.40039,
				y: 18,
				width: 12.15,
				height: 7.0875,
				fill: "#004EEB"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 17.5508,
				y: 10.9124,
				width: 12.15,
				height: 7.0875,
				fill: "#2970FF"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 5.40039,
				y: 10.9124,
				width: 12.15,
				height: 7.0875,
				fill: "#004EEB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.40039 8.82495C5.40039 6.06353 7.63897 3.82495 10.4004 3.82495H17.5504V10.9125H5.40039V8.82495Z",
				fill: "#2970FF"
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_1_38815)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-4.5 28C-4.5 25.7909 -2.70914 24 -0.5 24H21.5C23.7091 24 25.5 25.7909 25.5 28C25.5 30.2091 23.7091 32 21.5 32H-0.5C-2.70914 32 -4.5 30.2091 -4.5 28Z",
					fill: "black",
					fillOpacity: .3
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 25,
				width: 24,
				height: 8,
				rx: 4,
				fill: "url(#paint0_linear_1_38815)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.76989 28.8182C8.76989 29.2841 8.68466 29.6847 8.5142 30.0199C8.34375 30.3537 8.11009 30.6108 7.81321 30.7912C7.51776 30.9702 7.18182 31.0597 6.8054 31.0597C6.42756 31.0597 6.0902 30.9702 5.79332 30.7912C5.49787 30.6108 5.26491 30.353 5.09446 30.0178C4.92401 29.6825 4.83878 29.2827 4.83878 28.8182C4.83878 28.3523 4.92401 27.9524 5.09446 27.6186C5.26491 27.2834 5.49787 27.0263 5.79332 26.8473C6.0902 26.6669 6.42756 26.5767 6.8054 26.5767C7.18182 26.5767 7.51776 26.6669 7.81321 26.8473C8.11009 27.0263 8.34375 27.2834 8.5142 27.6186C8.68466 27.9524 8.76989 28.3523 8.76989 28.8182ZM8.1179 28.8182C8.1179 28.4631 8.06037 28.1641 7.94531 27.9212C7.83168 27.6768 7.67543 27.4922 7.47656 27.3672C7.27912 27.2408 7.0554 27.1776 6.8054 27.1776C6.55398 27.1776 6.32955 27.2408 6.1321 27.3672C5.93466 27.4922 5.77841 27.6768 5.66335 27.9212C5.54972 28.1641 5.4929 28.4631 5.4929 28.8182C5.4929 29.1733 5.54972 29.473 5.66335 29.7173C5.77841 29.9602 5.93466 30.1449 6.1321 30.2713C6.32955 30.3963 6.55398 30.4588 6.8054 30.4588C7.0554 30.4588 7.27912 30.3963 7.47656 30.2713C7.67543 30.1449 7.83168 29.9602 7.94531 29.7173C8.06037 29.473 8.1179 29.1733 8.1179 28.8182ZM13.1427 26.6364V31H12.5376L10.3196 27.7997H10.2791V31H9.62073V26.6364H10.2301L12.4503 29.8409H12.4908V26.6364H13.1427ZM14.7915 26.6364V31H14.1332V26.6364H14.7915ZM16.2384 26.6364L17.2825 28.343H17.3166L18.3606 26.6364H19.1234L17.764 28.8182L19.1319 31H18.3649L17.3166 29.3168H17.2825L16.2342 31H15.4671L16.8585 28.8182L15.4757 26.6364H16.2384Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1_38815",
			x1: .5,
			y1: 29,
			x2: 24.5,
			y2: 29,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DC2626" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E93030"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1_38815",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 31,
				height: 36,
				fill: "white",
				transform: "translate(0.5)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_1_38815",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 8,
				fill: "white",
				transform: "translate(5.5 24)"
			})
		})
	] })]
});
export default SvgOnixFileIcon;
